import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { CheckboxModule } from 'primeng/checkbox';
import { FieldsetModule } from 'primeng/fieldset';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TimelineModule } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { ToastService } from '../../common/services/toast.service';

interface TimelineEvent {
  step: number;
  title: string;
  description: string;
  icon: string;
  color: string;
}

@Component({
  selector: 'app-relias-learning-component',
  imports: [
    ButtonModule,
    InputTextModule,
    ReactiveFormsModule,
    AccordionModule,
    TextareaModule,
    SelectModule,
    CheckboxModule,
    FieldsetModule,
    RouterModule,
    CommonModule,
    TimelineModule,
    CardModule,
    DialogModule
  ],
  templateUrl: './homepage.html',
  styleUrls: ['./homepage.css'],
})
export class HomePageComponent {
  
  router = inject(Router);
  toastService = inject(ToastService);
  toolCredentialsDialogVisible:boolean = false;
  timelineEvents: TimelineEvent[] = [
    {
      step: 1,
      title: 'Get Credentials from Tool',
      description: `Get all necc. credentials from the Tool Provider.`,
      icon: 'pi pi-download',
      color: '#607D8B',
    },
    {
      step: 2,
      title: 'Create the Tool',
      description: 'Register the tool in the platform with the received credentials and configure endpoints.',
      icon: 'pi pi-wrench',
      color: '#9C27B0'
    },
    {
      step: 3,
      title: 'Generate Credentials for Tool',
      description: 'Generate platform credentials: Issuer URL, Authorization URL, Token URL, and JWKS URL.',
      icon: 'pi pi-key',
      color: '#FF9800'
    },
    {
      step: 4,
      title: 'Share Credentials with Tool',
      description: 'Provide the platform credentials to the tool provider to complete the registration.',
      icon: 'pi pi-share-alt',
      color: '#4CAF50'
    },
    {
      step: 5,
      title: 'Deep Linking / Test Launch',
      description: 'Perform deep linking to select content, or test a direct launch to verify the integration.',
      icon: 'pi pi-play',
      color: '#2196F3'
    }
  ];
  showDialog(){
    this.toolCredentialsDialogVisible = !this.toolCredentialsDialogVisible
  }
  goToAddTool(){
    this.router.navigate(['/add-tool'])
  }
  goToDeeplinkPage(){
    this.router.navigate(['/view-shell-courses'])
  }

  copyCredentialsToClipboard() {
    const text = `Tool URL,
\nPublic Keyset URL,
\nInitiate Login URL,
\nRedirect URL,
\nDoes it support Deep Linking?,
  \nIf yes, then Deep Linking URL`;
    navigator.clipboard.writeText(text);
    this.toastService.show({
      severity:"success",
      summary:"Copied!",
      detail:"Copied to clipboard."
    })
  }
  goToViewToolsPage(){
    this.router.navigate(['/view-tools'])
  }
}


